var _defs, _defs2, _defs3, _defs4, _defs5, _defs6;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgSuperTasty = function SvgSuperTasty(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 400 400",
    style: {
      enableBackground: "new 0 0 400 400"
    },
    xmlSpace: "preserve"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SuperTasty_svg__a",
    d: "M95.2 86h210.6v212.4H95.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SuperTasty_svg__b"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SuperTasty_svg__a",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SuperTasty_svg__b)",
      enableBackground: "new"
    }
  }, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SuperTasty_svg__c",
    d: "M92.7 84.3h214.1v216.5H92.7z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SuperTasty_svg__d"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SuperTasty_svg__c",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SuperTasty_svg__d)"
    }
  }, _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SuperTasty_svg__e",
    d: "m277 263.4-20.1-7.9c-1.9-.7-3.8.9-3.4 2.9l4.4 21.2c.5 2.3-2.2 4-4 2.5l-17.1-13.3c-1.6-1.2-3.9-.2-4.1 1.8l-1.7 21.6c-.2 2.4-3.2 3.2-4.6 1.3l-12.7-17.6c-1.2-1.6-3.7-1.3-4.4.6l-7.7 20.2c-.8 2.2-4 2.2-4.8-.1l-7.2-20.4c-.7-1.9-3.2-2.3-4.4-.7l-13.1 17.2c-1.4 1.9-4.4 1-4.6-1.4l-1.2-21.6c-.1-2-2.4-3.1-4-1.9l-17.4 12.8c-1.9 1.4-4.5-.3-4-2.6l5-21.1c.5-2-1.4-3.7-3.3-3l-20.3 7.4c-2.2.8-4.2-1.6-3.1-3.6l10.7-18.8c1-1.8-.4-3.9-2.4-3.8l-21.6 1.4c-2.4.2-3.6-2.7-1.9-4.4l15.6-15c1.4-1.4.8-3.9-1.2-4.3L97.3 208c-2.3-.5-2.7-3.6-.6-4.7l19.2-10.1c1.8-.9 1.8-3.5.1-4.5l-18.9-10.5c-2.1-1.1-1.6-4.2.7-4.7l21.2-4.2c2-.4 2.7-2.8 1.3-4.3l-15.2-15.4c-1.7-1.7-.3-4.5 2-4.3l21.6 1.9c2 .2 3.4-1.9 2.5-3.7L121 124.4c-1.1-2.1 1-4.4 3.2-3.6l20.2 7.9c1.9.7 3.8-.9 3.4-2.9l-4.4-21.2c-.5-2.3 2.2-4 4-2.5l17.1 13.3c1.6 1.2 3.9.2 4.1-1.8l1.7-21.6c.2-2.4 3.2-3.2 4.6-1.3l12.7 17.6c1.2 1.6 3.7 1.3 4.4-.6l7.7-20.2c.8-2.2 4-2.2 4.8.1l7.2 20.4c.7 1.9 3.2 2.3 4.4.7l13.1-17.2c1.4-1.9 4.4-1 4.6 1.4l1.2 21.6c.1 2 2.4 3.1 4 1.9l17.4-12.8c1.9-1.4 4.5.3 4 2.6l-5 21.1c-.5 2 1.4 3.7 3.3 3l20.3-7.4c2.2-.8 4.2 1.6 3.1 3.6l-10.7 18.8c-1 1.8.4 3.9 2.4 3.8l21.6-1.4c2.4-.2 3.6 2.7 1.9 4.4l-15.6 15c-1.4 1.4-.8 3.9 1.2 4.3l21.1 4.8c2.3.5 2.7 3.6.6 4.7L285.2 191c-1.8.9-1.8 3.5-.1 4.5L304 206c2.1 1.1 1.6 4.2-.7 4.7l-21.2 4.2c-2 .4-2.7 2.8-1.3 4.3l15.2 15.4c1.7 1.7.3 4.5-2 4.3l-21.6-1.9c-2-.2-3.4 1.9-2.5 3.7l10.2 19.1c1.2 2.1-.9 4.4-3.1 3.6"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SuperTasty_svg__f"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SuperTasty_svg__e",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SuperTasty_svg__f)"
    }
  }, _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SuperTasty_svg__g",
    d: "M95.2 84.3h211.6v214.1H95.2z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SuperTasty_svg__h"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SuperTasty_svg__g",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SuperTasty_svg__h)",
      fill: "#fcb618"
    },
    d: "M82.9 73.7h235.2v237H82.9z"
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SuperTasty_svg__i",
    d: "m159.9 214.1-6.6 1.1 3.5 20.6-6.2 1.1-3.5-20.6-6.6 1.1-1-5.6 19.5-3.3.9 5.6zm19.4 9.3-10.2 1.8-1.8 8.8-6.6 1.1 6.3-28 8.4-1.4 15.2 24.4-6.6 1.1-4.7-7.8zm-8.5-7.5-.8 4.1 6.8-1.2-2.1-3.6c-.8-1.4-1.8-3.1-2.6-4.5l-.3.1c-.4 1.5-.7 3.5-1 5.1zm16.6 3.9 7-1.2c.8 3.5 3.4 5.1 7.1 4.5 3-.5 4.7-2.2 4.3-4.3-.3-2-2-2.3-3.5-2.2l-5.4.2c-5 .2-7.8-1.7-8.5-5.7-.8-4.8 2.3-8.5 8.4-9.6 5.9-1 10.4 1.2 11.6 5.8l-6.6 1.2c-.8-1.9-2.3-2.6-4.4-2.2-1.9.3-3.1 1.5-2.8 3.1.3 1.7 2 1.8 3.3 1.8l4.9-.2c5.4-.2 8.7 1.9 9.5 6.3.9 5.5-2.8 9.8-9.9 11.1-8.1 1.3-13.7-2.5-15-8.6zm41.5-17.6-6.6 1.1 3.5 20.6-6.2 1.1-3.5-20.6-6.6 1.1-1-5.6 19.5-3.3.9 5.6zm12.2 9.7-12.3-15.5 7-1.2 7.3 10.1h.1l3.6-11.9 7-1.2-6.5 18.7 1.5 9.1-6.2 1.1-1.5-9.2zm14.9-20.2 6.4-1.1 2.4 16.5-5.7 1-3.1-16.4zm2.8 23c-.4-2.2 1.2-4.1 3.6-4.5 2.4-.4 4.5.9 4.9 3.1.4 2.2-1.2 4.1-3.6 4.5-2.4.4-4.5-.9-4.9-3.1zm-119.3-27.2 7-1.2c.8 3.5 3.4 5.1 7.1 4.5 3-.5 4.7-2.2 4.3-4.3-.3-2-2-2.3-3.5-2.2l-5.4.2c-5 .2-7.8-1.7-8.5-5.7-.8-4.8 2.3-8.5 8.4-9.6 5.9-1 10.4 1.2 11.6 5.8l-6.6 1.2c-.7-1.9-2.3-2.6-4.4-2.3-1.9.3-3.1 1.6-2.8 3.1.3 1.7 2 1.8 3.3 1.8l4.9-.2c5.4-.2 8.7 1.9 9.5 6.3.9 5.5-2.8 9.8-9.9 11.1-8.2 1.4-13.8-2.4-15-8.5zm26.6-4.5-2.7-15.9 6.3-1.1 2.7 15.8c.5 3.1 2.7 4.8 5.6 4.3 2.9-.5 4.4-2.7 3.8-5.9l-2.7-15.8 6.2-1.1 2.7 15.9c1.1 6.5-2.4 11.4-9.1 12.5-6.7 1.2-11.6-2.1-12.8-8.7zm33.8-22.2c5.8-1 10.4 1.9 11.3 7.2.9 5.3-2.5 9.6-8.3 10.6l-4.4.7 1.4 8.4-6.2 1.1-4.4-26.2 10.6-1.8zm1.2 12.6c2.6-.4 3.9-2.1 3.5-4.3-.4-2.2-2.2-3.3-4.7-2.9l-3.5.6 1.2 7.2 3.5-.6zm17.5-10.6.9 5.1 9.8-1.7.9 5-9.8 1.7 1 5.8 10-1.7.9 5.1-16 2.7-4.4-26.2 16-2.7.9 5.1-10.2 1.8zm22.8 7.1-1.3.2 1.8 10.4-6 1-4.4-26.2 11.9-2c5.2-.9 9.3 1.6 10.1 6.4.7 3.9-1.2 7.3-4.8 8.7l11.5 8.9-8 1.4-10.8-8.8zm-2-3.8 4.6-.8c2.4-.4 3.6-2 3.3-4.1-.4-2.1-2-3.1-4.4-2.7l-4.6.8 1.1 6.8z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SuperTasty_svg__j"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SuperTasty_svg__i",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#SuperTasty_svg__j)"
    }
  }, _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SuperTasty_svg__k",
    d: "M-328-240.5h2952.4v1395H-328z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SuperTasty_svg__l"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SuperTasty_svg__k",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SuperTasty_svg__l)",
      fill: "#5c0425"
    },
    d: "M127.1 140.9h152.5v108.3H127.1z"
  })));
};

export default SvgSuperTasty;